import { BusinessRuleRamoService } from './../../../../services/business-rule-ramo.service';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  SimpleChange,
} from '@angular/core';
import { PageEvent, MatRadioChange } from '@angular/material';
import { DecimalPipe } from '@angular/common';
import * as moment from 'moment';
import { IPagosProducto } from 'src/app/shared/Entities/webPay.entities';
import { paginatorConfig, PipeEnum, tipoPrima } from 'src/app/shared/helpers/constants';
import {
  IColumnsDataTable,
  IPolizaPagoPendiente,
  IResumenPoliza,
} from './../../../../Entities/entities';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { PersonService } from '../../../../../shared/services/person.service';
import { getBase64ImageFromURL } from 'src/app/functions/getbase64ImageFromUrl';
import { formateaRut } from 'src/app/shared/helpers/helper';

export const pagoMock: IPolizaPagoPendiente = {
  Poliza: 2,
  Rut: '23213213-2',
  IdePol: '323233',
  Producto: 'ACCIDENTES PERSONALES 2009',
  Monto: 57000,
  Periodo: '07-2016',
  NumAviso: 2,
  DigAviso: '2',
  FechaVencimiento: '07-2016',
  TipoProducto: 'tipo',
  TipoPrima: tipoPrima.periodica,
  MedioPago: '',
  NombreProducto: 'ACCIDENTES PERSONALES 2009',
  Monto_UF: 2,
  CodigoMoneda: 'CLP',
  Checked: false,
};

@Component({
  selector: 'app-card-pagar-producto',
  templateUrl: './card-pagar-producto.component.html',
  styleUrls: ['./card-pagar-producto.component.sass'],
})
export class CardPagarProductoComponent implements OnInit, OnChanges {
  @Input() displayedColumns: IColumnsDataTable[];
  @Input() displayedColumnsACobranza: IColumnsDataTable[];
  @Input() producto: IPagosProducto;
  @Output() $onRealizarAporte = new EventEmitter<IPolizaPagoPendiente[]>();
  @Input() codigoRamo: any;
  @Input() showPeriodicas: boolean;
  @Input() showImpagosPFEspecial: boolean;
  @Input() showEsporadicas: boolean;
  @Input() showTotalResumen: boolean;
  @Input() showMode: boolean;
  @Input() resumen: IResumenPoliza;
  @Output() $onChangeAviso = new EventEmitter<boolean>();
  @Input() pagoSeleccionado: string;
  @Input() tabLabel: string;
  isAPVSelectDirect: boolean;
  data: IPolizaPagoPendiente[];
  dataBack: IPolizaPagoPendiente[];
  pagoStyle = true;
  paginatorLength = paginatorConfig.paginatorLength;
  pageSize = paginatorConfig.pageSize;
  pageSizeOptions: number[] = paginatorConfig.pageSizeOptions;
  showMessageCuiNoApv = false;
  showMessageCuiApvRegimen = false;
  showMessageNoCuiPF = false;
  showMessageDecember = false;
  showAporteCUI = false;
  base64template;
  pagos: string[] = ['Pagar online', 'Pagar en Banco con aviso de cobranza'];
  constructor(
    private businessRule: BusinessRuleRamoService,
    private personService: PersonService
  ) {}

  ngOnInit() {
    this.dataBack = this.producto.PagosPendientes;
    this.paginatorLength = this.dataBack ? this.dataBack.length : 0;
    this.data = this.dataBack ? this.dataBack.slice(0, this.pageSize) : [];

    if(this.resumen.CodigoRamo.includes('1200') || this.resumen.CodigoRamo.includes('1300'))
    {
      this.createDisplayedColumnsCurrencyCod(this.resumen.CodigoMonedaCapital);
    }

    if (this.tabLabel == 'APORTES') {
      this.showAporteCUI = true;
    }

    getBase64ImageFromURL(
      '../../../assets/template/AVISO_COBRANZA_FORMATO.png'
    ).subscribe(base => {
      this.base64template = 'data:image/png;base64,' + base;
    });
    this.isAPVSelectDirect = this.resumen &&((this.resumen.CodigoRamo === '9661' || this.resumen.CodigoRamo === '9662') && this.resumen.ViaPago === 'DIRECTO') ? true : false;
  }

  ngOnChanges(changes: SimpleChanges) {
    const resumen: SimpleChange = changes.resumen;
    if (resumen && resumen.currentValue) {
      this.showMessageCuiNoApv = this.businessRule.showMessageCuiNoApv(
        resumen.currentValue.CodigoRamo
      );
      this.showMessageCuiApvRegimen = this.businessRule.showMessageCuiApvRegimen(
        resumen.currentValue.CodigoRamo
      );

      this.showMessageNoCuiPF = this.businessRule.showNoCuiPF(
        resumen.currentValue
      );

      this.showMessageDecember = this.businessRule.showMessageDecember();
    }
    this.isAPVSelectDirect = this.resumen &&((this.resumen.CodigoRamo === '9661' || this.resumen.CodigoRamo === '9662') && this.resumen.ViaPago === 'DIRECTO') ? true : false;
  }

  onChangeMode(e: MatRadioChange) {
    if (e.value.includes('online')) {
      this.$onChangeAviso.emit(true);
    } else {
      this.$onChangeAviso.emit(false);
    }
  }

  getDataPaginator(event: PageEvent) {
    const end = (event.pageIndex + 1) * event.pageSize;
    // this.data = [];
    this.data = this.dataBack.slice(event.pageIndex * event.pageSize, end);
  }

  onIconClick(item) {
    const rut = item.item.Rut.slice(0, -2);
    const dv = item.item.Rut.substr(item.item.Rut.length - 1);

    this.personService.GetClientProfile(rut, dv).subscribe(data => {
      let nombre = '';
      if (data.httpCode == 200 && data.client) {
        nombre =
          data.client.names +
          ' ' +
          data.client.paternalLastName +
          ' ' +
          data.client.maternalLastName;
      }
      this.generatePdf(item, nombre);
    });
  }

  generatePdf(element, nombre) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const numAviso = element.item.NumAviso + '-' + element.item.DigAviso;
    const rutFormat = formateaRut(element.item.Rut.replace('-', ''));
    const fechaVen = moment(element.item.FechaVencimiento).format('DD/MM/YYYY');

    const nomProducto = element.item.NombreProducto;
    const numPoliza = element.item.Poliza;
    const periodoPrima = element.item.Periodo.replace('-', '/');
    const montoPrimaUF = element.item.Monto_UF.toString().replace('.', ',');
    const codMoneda = element.item.CodigoMoneda;
    const montoPrima = new DecimalPipe('es-CL').transform(
      element.item.Monto.toString()
    );

    const dd = {
      pageSize: 'LETTER',
      pageMargins: [0, 0],
      background: [
        {
          image: this.base64template,
          width: 595,
          height: 842,
        },
      ],
      content: [
        //COPIA CLIENTE
        {
          text: numAviso,
          style: ['head1'],
          absolutePosition: { x: 370, y: 20 },
        },
        {
          text: nombre,
          style: ['paragraph1'],
          absolutePosition: { x: 28, y: 73 },
        },
        {
          text: rutFormat,
          style: ['paragraph1'],
          absolutePosition: { x: 260, y: 73 },
        },
        {
          text: fechaVen,
          style: ['paragraph1'],
          absolutePosition: { x: 485, y: 73 },
        },
        {
          text: nomProducto,
          style: ['paragraph2'],
          absolutePosition: { x: 25, y: 118 },
        },
        {
          text: numPoliza,
          style: ['paragraph2'],
          absolutePosition: { x: 120, y: 118 },
        },
        {
          text: periodoPrima,
          style: ['paragraph2'],
          absolutePosition: { x: 190, y: 118 },
        },
        {
          text: montoPrimaUF,
          style: ['paragraph2'],
          absolutePosition: { x: 280, y: 118 },
        },
        {
          text: codMoneda,
          style: ['paragraph2'],
          absolutePosition: { x: 335, y: 118 },
        },
        {
          text: montoPrima,
          style: ['paragraph2'],
          absolutePosition: { x: 400, y: 118 },
        },

        //COPIA VIDA SECURITY
        {
          text: numAviso,
          style: ['head1'],
          absolutePosition: { x: 370, y: 348 },
        },
        {
          text: nombre,
          style: ['paragraph1'],
          absolutePosition: { x: 28, y: 386 },
        },
        {
          text: rutFormat,
          style: ['paragraph1'],
          absolutePosition: { x: 260, y: 386 },
        },
        {
          text: fechaVen,
          style: ['paragraph1'],
          absolutePosition: { x: 485, y: 386 },
        },
        {
          text: nomProducto,
          style: ['paragraph2'],
          absolutePosition: { x: 25, y: 433 },
        },
        {
          text: numPoliza,
          style: ['paragraph2'],
          absolutePosition: { x: 120, y: 433 },
        },
        {
          text: periodoPrima,
          style: ['paragraph2'],
          absolutePosition: { x: 190, y: 433 },
        },
        {
          text: montoPrimaUF,
          style: ['paragraph2'],
          absolutePosition: { x: 280, y: 433 },
        },
        {
          text: codMoneda,
          style: ['paragraph2'],
          absolutePosition: { x: 335, y: 433 },
        },
        {
          text: montoPrima,
          style: ['paragraph2'],
          absolutePosition: { x: 400, y: 433 },
        },

        //COPIA RECAUDADOR
        {
          text: numAviso,
          style: ['head1'],
          absolutePosition: { x: 370, y: 601 },
        },
        {
          text: nombre,
          style: ['paragraph1'],
          absolutePosition: { x: 28, y: 639 },
        },
        {
          text: rutFormat,
          style: ['paragraph1'],
          absolutePosition: { x: 260, y: 639 },
        },
        {
          text: fechaVen,
          style: ['paragraph1'],
          absolutePosition: { x: 485, y: 639 },
        },
        {
          text: numPoliza,
          style: ['paragraph2'],
          absolutePosition: { x: 80, y: 662 },
        },
      ],
      styles: {
        head1: {
          bold: true,
          fontSize: 11,
          font: 'Roboto',
        },
        paragraph1: {
          alignment: 'justify',
          fontSize: 8,
          bold: true,
          font: 'Roboto',
        },
        paragraph2: {
          alignment: 'justify',
          fontSize: 8,
          font: 'Roboto',
        },
      },
    };

    pdfMake
      .createPdf(dd)
      .download(
        'AVISO_' + numPoliza + '_' + periodoPrima.replace('/', '') + '.pdf'
      );
  }

  onRealizarAporte(event) {
    let monto = '0';
    let medio = '';

    if (event.monto && event.medio) {
      monto = event.monto;
      medio = event.medio;
    } else {
      monto = event;
    }

    const data = [
      {
        Monto: parseFloat(monto),
        NombreProducto: this.producto.Producto.Nombre,
        TipoPrima: tipoPrima.esporadica,
        MedioPago: medio,
        Poliza: this.producto.Producto.Poliza,
        Periodo: moment().format('MM-YYYY'),
        Checked: true,
      },
    ] as IPolizaPagoPendiente[];

    this.$onRealizarAporte.emit(data);
  }

  showRegimen(regimen: string) {
    return this.resumen.RegimenTributario === regimen;
  }

  dateAnnio() {
    var currentdate = new Date();
    return currentdate.getFullYear();
  }

  createDisplayedColumnsCurrencyCod(currencyCod: string) {
    this.displayedColumns = [
      {
        ColumnDef: 'Checked',
        ColumnName: '',
        CheckBox: true,
      },
      {
        ColumnDef: 'Periodo',
        ColumnName: 'PER�ODO',
        // Pipe: PipeEnum.da,
      },
      {
        ColumnDef: 'Monto_UF',
        ColumnName: `MONTO (${currencyCod.toUpperCase()})`,
        Pipe: PipeEnum.UFPipe,
      },
      {
        ColumnDef: 'Monto',
        ColumnName: 'MONTO ($)',
        Pipe: PipeEnum.decimalPipe,
      },
    ] as IColumnsDataTable[];
  }
}
